import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';

import createRavenMiddleware from 'raven-for-redux';
import reducers from './reducers';


export function configureStore(initialState) {
  const middlewares = [
    promiseMiddleware(),
    thunkMiddleware,
  ];

  if (process.env.NODE_ENV === 'development') {
    const { createLogger } = require('redux-logger'); // eslint-disable-line global-require
    middlewares.push(
      createLogger(),
    );
  }

  if (window.Raven) {
    middlewares.push(createRavenMiddleware(window.Raven, {}));
  }

  const store = createStore(reducers, initialState, applyMiddleware(...middlewares));

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}


const initialState = window.injected_store || {};

export default configureStore(initialState);
